import {Injectable} from '@angular/core';
import {BodyOutputType, ToasterService} from 'angular2-toaster';

@Injectable()
export class HttpErrorsService {
  constructor(public toasterService: ToasterService) {}

  handleError(title: string, error: any, stayOpen?: boolean, locale?: string) {
    console.error(error);
    let message = '';
    if (error && error.error && error.error.error && error.error.error.message) {
      if (error.error.error.message === 'No message available') {
        message = error.error.error.exception;
      } else {
        message = error.error.error.message;
      }
    } else if (error && error.error && error.error.error) {
      try {
        message = JSON.stringify(error.error.error);
        if (Object.keys(message).length === error.error.error.length + 2) {
          // This is not really a JSON object, it's just a string.
          message = error.error.error;
        }
      } catch (e) {
        message = error.error;
      }
    } else if (error && error.error && typeof error.error === 'string') {
      message = error.error;
    } else if (error && error.status && error.statusText) {
      message = error.status + ' ' + error.statusText;
    } else if (error && error.message) {
      message = error.message;
    } else {
      message = JSON.stringify(error);
    }

    if (message && message.indexOf('A different user or different window has modified the application') !== -1) {
      stayOpen = true;
    }

    if (stayOpen) {
      this.toasterService.pop({
        type: 'error',
        title: title,
        body: message,
        showCloseButton: true,
        timeout: 0
      });
    } else {
      this.toasterService.pop({
        type: 'error',
        title: title,
        body: message,
        bodyOutputType: BodyOutputType.TrustedHtml
      });
    }
  }
}
